import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import { ScreensContext } from '../contexts/screensContext';
import WelcomeScreen from '../components/26ua-prl-p/welcome-screen';
import PreWelcomeAgeVerification from '../components/26ua-prl-p/pre-welcome-age-verification';
import NotAllowed from '../components/26ua-prl-p/not-allowed';
import NewPackCharacteristicsScreen from '../components/26ua-prl-p/new-pack-characteristics-screen';
import ReviewFlowScreen from '../components/26ua-prl-p/review-flow-screen';
import PageFlowWrapper from '../common/registration-flow-wrapper';
import CookieConsentFlowWrapper from '../common/cookie-consent-flow-wrapper';
import BrandLineScreen from '../common/brand-line-screen';
import AllBrandsScreen from '../common/all-brands-screen';
import useScreenHistory from '../hooks/useScreenHistory';

const UaPrlP = () => {
  const { screenNumber, setScreenNumber, historyState, updateHistoryState } =
    useScreenHistory({
      initialScreen: 0,
      initialState: { brandLine: 'parliament' }
    });

  const brandLine = historyState.brandLine || 'parliament';

  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const skipWrapper = user?.AV_Status && user?.CDA_Status;

  const { init } = useContext(DataLayerEventContext);

  useEffect(() => {
    init('24UA-PRL-P');
    sessionStorage.setItem('unsubscription_source', '24UA-PRL-P');
  }, [init]);

  const getScreen = (number) => {
    switch (number) {
      case 0: {
        return (
          <PreWelcomeAgeVerification
            handleNextButtonClick={() => setScreenNumber(2)}
            handleNotAllowed={() => setScreenNumber(1)}
          />
        );
      }
      case 1:
        return <NotAllowed />;
      case 2:
        return <WelcomeScreen handleToProduct={() => setScreenNumber(3)} />;
      case 3: {
        const content = (
          <NewPackCharacteristicsScreen
            handleToReview={() => {
              setScreenNumber(4);
            }}
            handleToBrandLinePage={() => {
              setScreenNumber(5);
            }}
          />
        );
        return skipWrapper ? (
          content
        ) : (
          <PageFlowWrapper
            isDarkMode
            withoutCookieModal
            externalScreenNumber={historyState.innerScreenNumber}
            setExternalScreenNumber={(val) =>
              setScreenNumber(3, false, { innerScreenNumber: val })
            }
          >
            {content}
          </PageFlowWrapper>
        );
      }
      case 4:
        return (
          <ReviewFlowScreen
            isDarkMode
            setScreenNumber={setScreenNumber}
            backToMenuButtonClick={() => setScreenNumber(3, true)}
            innerScreenNumber={historyState.innerScreenNumber}
            setInnerScreenNumber={(val) =>
              setScreenNumber(4, false, { innerScreenNumber: val })
            }
          />
        );
      case 5: {
        return (
          <BrandLineScreen
            brandId={brandLine}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(6, true)}
            nextButtonClick={() => setScreenNumber(3)}
            withoutHeader
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 6: {
        return (
          <AllBrandsScreen
            setScreenNumber={setScreenNumber}
            setBrandLine={(brand) => {
              setScreenNumber(5, false, { brandLine: brand });
            }}
            handleBackButton={() => setScreenNumber(3, true)}
            withoutHeader
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={setScreenNumber} />;
      }
    }
  };

  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      <CookieConsentFlowWrapper>
        {getScreen(screenNumber)}
      </CookieConsentFlowWrapper>
    </ScreensContext.Provider>
  );
};

export default UaPrlP;
